import {BiInfoCircle} from 'react-icons/bi'
// import {Buttons} from './Buttons'

import {PhonesExtended} from './PhonesExtended'
import {EmailsExtended} from './EmailsExtended'
import {RelatedPeople} from './RelatedPeople'
import {RelatedPeopleEmails} from './RelatedPeopleEmails'
import {RelatedPeoplePhones} from './RelatedPeoplePhones'
import {AddressesExtended} from './AddressesExtended'
import {dadosTabelas} from '../../../../../components/Reports/partials/EstrtuturaBDC'
import {BasicData} from '../../../../pessoas/components/BasicaData'
import {InfoDadosPessoas} from '../../../../pessoas/components/InfoDadosPessoas'
import {RelatedPeopleBDC} from '../../../../pessoas/components/RelatedPeopleBDC'
import {Buttons} from '../../../../pessoas/components/Buttons'
//import { PhonesExtended } from '../../../../pessoas/components/PhonesExtended'
// import {PhonesExtended} from '../../../components/Modals/Proprietarios/PhonesExtended'

export function statusPhones(status) {
  switch (status) {
    case 0:
      return 'Inativo'
    case 1:
      return 'Ativo'
    case 2:
      return 'Verificado'
    case 3:
      return 'Hot'
  }
}

export function Row({response, idImovel, clickRow, updateList}) {
  // var dadosTabelas = {}
  // dadosTabelas['cpf'] = {}
  // dadosTabelas['cnpj'] = {}

  // dadosTabelas['cpf']['BasicData'] = {
  //   'key': 'BasicData',
  //   'titulo': 'Dados Principais',
  //   'coluns': ['Name', 'Age', 'BirthDate', 'BirthCountry', 'Gender', 'FatherName', 'MotherName'],
  //   'colunsItens': []
  // };

  // dadosTabelas['cpf']['PhonesExtended'] = {
  //   'key': 'ExtendedPhones',
  //   'titulo': 'Telefones',
  //   'coluns': ['Phones'],
  //   'colunsItens': ['CountryCode', 'AreaCode', 'Number']
  // }
  // dadosTabelas['cpf']['EmailsExtended'] = {
  //   'key': 'ExtendedEmails',
  //   'titulo': 'E-mails',
  //   'coluns': ['Emails'],
  //   'colunsItens': ['EmailAddress', 'UserName', 'Type']
  // }
  // dadosTabelas['cpf']['AddressesExtended'] = {
  //   'key': 'ExtendedAddresses',
  //   'titulo': 'Endereços',
  //   'coluns': ['Addresses'],
  //   'colunsItens': ['Typology', 'AddressMain', 'Number', 'Neighborhood', 'City', 'State', 'ZipCode', 'Complement', 'Type']
  // }

  // dadosTabelas['cpf']['RelatedPeople'] = {
  //   'key': 'RelatedPeople',
  //   'titulo': 'Pessoas relacionadas',
  //   'coluns': ['PersonalRelationships'],
  //   'colunsItens': ['RelatedEntityName', 'RelatedEntityTaxIdNumber', 'RelationshipType']
  // }

  // dadosTabelas['cpf']['RelatedPeopleEmails'] = {
  //   'key': 'RelatedPeopleEmails',
  //   'titulo': 'E-mail pessoas relacionadas',
  //   'coluns': [],
  //   'colunsItens': ['EmailAddress', 'UserName', 'Type']
  // }

  // dadosTabelas['cpf']['RelatedPeoplePhones'] = {
  //   'key': 'RelatedPeoplePhones',
  //   'titulo': 'Telefones pessoas relacionadas',
  //   'coluns': [],
  //   'colunsItens': ['CountryCode', 'AreaCode', 'Number', 'Type']
  // }

  // dadosTabelas['cnpj']['BasicData'] = {
  //   'key': 'BasicData',
  //   'titulo': 'Dados Principais',
  //   'coluns': ['TradeName', 'OfficialName', 'TaxRegime', 'TaxIdStatusRegistrationDate', 'HeadquarterState', 'Age'],
  //   'colunsItens': [],
  //   'colunTotal': null
  // };

  // dadosTabelas['cnpj']['PhonesExtended'] = {
  //   'key': 'ExtendedPhones',
  //   'titulo': 'Telefones',
  //   'coluns': ['Phones'],
  //   'colunsItens': ['CountryCode', 'AreaCode', 'Number'],
  //   'colunTotal': 'TotalPhones'
  // }
  // dadosTabelas['cnpj']['EmailsExtended'] = {
  //   'key': 'ExtendedEmails',
  //   'titulo': 'E-mails',
  //   'coluns': ['Emails'],
  //   'colunsItens': ['EmailAddress', 'UserName', 'Type'],
  //   'colunTotal': 'TotalEmails'
  // }
  // dadosTabelas['cnpj']['AddressesExtended'] = {
  // 'key': 'ExtendedAddresses',
  // 'titulo': 'Endereços',
  // 'coluns': ['Addresses'],
  // 'colunsItens': ['Typology', 'AddressMain', 'Number', 'Neighborhood', 'City', 'State', 'ZipCode', 'Complement', 'Type'],
  // 'colunTotal': 'TotalAddresses'
  // }

  const typeDoc = response.cpf ? 'cpf' : 'cnpj'
  return (
    <>
      <tr>
        <td className='w-20px'>
          {response.basic_data ? (
            <button
              onClick={() => {
                clickRow(response.id)
              }}
              className='btn btn-icon btn-light-info btn-sm me-2'
            >
              <BiInfoCircle className='fs-1'></BiInfoCircle>
            </button>
          ) : (
            '-'
          )}
        </td>

        <td>
          <div className='d-flex align-items-center'>
            <div className='d-flex justify-content-center flex-column'>
              <p className='text-dark  fs-6'>{response.nome || response.empresa}</p>
            </div>
          </div>
        </td>
          <td>
          <p className='text-dark  d-block fs-6'>{response.grau_parentesco}</p>
        </td>
        <td>
          <p className='text-dark  d-block fs-6'>{response.email}</p>
        </td>
        <td>
          <Buttons
            id={response.id_terreno_proprietario}
            idProprietario={response.id}
            idTerreno={idImovel}
            cpf={response.cpf}
            quill_status={response.quill_status}
            quill_file={response.quill_file}
          ></Buttons>
          {/* <Buttons
            id={response.id_terreno_proprietario}
            idProprietario={response.id}
            idTerreno={idImovel}
            syncOk={response.basic_data ? true : false}
            updateList={updateList}
            showButtonSync={response.cpf || response.cnpj ? true : false}
          /> */}
        </td>
      </tr>

      <tr className='hide ' id={`detalhes_${response.id}`}>
        <td colSpan={7}>
          <div>
            <div className='card card-body'>
              <div>
                {<InfoDadosPessoas response={response} typeDoc={typeDoc}></InfoDadosPessoas>}

                {/* <h3 className='fw-semibold   mb-5 border-bottom border-success border-2'>
                  Dados Pessoais*****************
                </h3>

                {response.ph3a_data.DocumentType === 0 ? (
                  <>
                    <p className='fs-6'>Nome: {response.ph3a_data.Name} </p>
                    <p className='fs-6'>Idade: {response.ph3a_data.Age} </p>
                    <p className='fs-6'>Documento: {response.ph3a_data.DocumentFormatted} </p>
                    <p className='fs-6'>Mãe: {response.ph3a_data?.MotherName} </p>
                    {response.ph3a_data.DeathYear ? (
                      <p className='fs-6'>Óbito: em {response.ph3a_data.DeathYear} </p>
                    ) : (
                      <p className='fs-6'>Óbito:Não</p>
                    )}
                  </>
                ) : (
                  <>
                    <p className='fs-6'>Nome: {response.ph3a_data.Name} </p>
                    <p className='fs-6'>Idade: {response.ph3a_data.Age} </p>
                    <p className='fs-6'>Documento: {response.ph3a_data.DocumentFormatted} </p>
                  </>
                )} */}

                {/* <h3 className='fw-semibold mt-8  mb-5 border-bottom border-success border-2'>
                  Telefones
                </h3>

                {response.ph3a_data.Phones && response.ph3a_data.Phones.length > 0 ? (
                  <>
                    {response.ph3a_data.Phones.map((phones, index) => {
                      return (
                        <div key={index}>
                          <p className='fs-6'>
                            Telefone: {phones.FormattedNumber} - Operador {phones.Operator}
                            <br />
                            Whatsapp: {phones.IsWhatsapp ? 'Sim' : 'Não'}
                          </p>
                        </div>
                      )
                      // }
                    })}
                  </>
                ) : (
                  <></>
                )} */}
                {/* {response.phones_extended && response.phones_extended.length > 0 ? (
                  <PhonesExtended
                    data={response.phones_extended}
                    estrutura={dadosTabelas[typeDoc]['PhonesExtended']}
                  ></PhonesExtended>
                ) : (
                  <></>
                )}

                {response.emails_extended && response.emails_extended.length > 0 ? (
                  <>
                    <EmailsExtended
                      data={response.emails_extended}
                      estrutura={dadosTabelas[typeDoc]['EmailsExtended']}
                    ></EmailsExtended>
                  </>
                ) : (
                  <div>Nada consta</div>
                )}

                <h3 className='fw-semibold  mt-8   mb-5 border-bottom border-success border-2'>
                  Pessoas Relacionadas
                </h3>
                {typeDoc === 'cpf' ? (
                  <>
                    {response.related_people ? (
                      <RelatedPeople
                        data={response.related_people}
                        estrutura={dadosTabelas[typeDoc]['RelatedPeople']}
                      ></RelatedPeople>
                    ) : (
                      ''
                    )}
                    {response.related_people_emails ? (
                      <RelatedPeopleEmails
                        data={response.related_people_emails}
                        estrutura={dadosTabelas[typeDoc]['RelatedPeopleEmails']}
                      ></RelatedPeopleEmails>
                    ) : (
                      ''
                    )}
                    {response.related_people_phones ? (
                      <RelatedPeoplePhones
                        data={response.related_people_phones}
                        estrutura={dadosTabelas[typeDoc]['RelatedPeoplePhones']}
                      ></RelatedPeoplePhones>
                    ) : (
                      ''
                    )}
                  </>
                ) : (
                  ''
                )} */}

                {/* {response.related_people && response.related_people.length > 0 ? (
                  <RelatedPeople
                    data={response.related_people}
                    estrutura={dadosTabelas[typeDoc]['RelatedPeople']}
                  ></RelatedPeople>
                ) : (
                  <></>
                )} */}
                {/* {response ? (
                  response?.ph3a_data?.Relateds ? (
                    response?.ph3a_data?.Relateds.length > 0 ? (
                      <RelatedPeopleBDC
                        data={response?.ph3a_data?.Relateds}
                        // estrutura={response['RelatedPeople']}
                      ></RelatedPeopleBDC>
                    ) : (
                      <></>
                    )
                  ) : (
                    <></>
                  )
                ) : (
                  <>Nada Constaxxx</>
                )} */}
                {/* <h3 className='fw-semibold  mt-8   mb-5 border-bottom border-success border-2'>
                  E-mails Pessoas Relacionadas
                </h3>
                {response.related_people_emails && response.related_people_emails.length > 0 ? (
                  <RelatedPeopleEmails
                    data={response.related_people_emails}
                    estrutura={dadosTabelas[typeDoc]['RelatedPeopleEmails']}
                  ></RelatedPeopleEmails>
                ) : (
                  <>Nada Consta</>
                )} */}
                {/* <h3 className='fw-semibold  mt-8  mb-5 border-bottom border-success border-2'>
                  Telefones Pessoas Relacionadas
                </h3>
                {response.related_people_phones && response.related_people_phones.length > 0 ? (
                  <RelatedPeoplePhones
                    data={response.related_people_phones}
                    estrutura={dadosTabelas[typeDoc]['RelatedPeoplePhones']}
                  ></RelatedPeoplePhones>
                ) : (
                  <div>Nada Consta</div>
                )} */}

                {/* {response.addresses_extended && response.addresses_extended.length > 0 ? (
                  <AddressesExtended
                    data={response.addresses_extended}
                    estrutura={dadosTabelas[typeDoc]['AddressesExtended']}
                  ></AddressesExtended>
                ) : (
                  <></>
                )}

                {response.Addresses && response.Addresses.length > 0 ? (
                  response.Addresses.map((address, index) => {
                    return (
                      <div key={index}>
                        <p className='fs-6'>Endereço: {address.Alias}</p>
                        <p className='fs-6'>Complemento: {address.ComplementFormatted}</p>
                        <p className='fs-6'>Distrito: {address.District}</p>
                        <p className='fs-6'>Endereço: {address.City}</p>
                        <p className='fs-6'>Estado: {address.State}</p>
                        <p className='fs-6'>
                          <hr />
                        </p>
                      </div>
                    )
                  })
                ) : (
                  <></>
                )} */}
              </div>
              {/* {<InfoDadosPessoas response={response} typeDoc={typeDoc}></InfoDadosPessoas>} */}

              {/* {response.basic_data ? (
                <BasicData
                  data={response.basic_data}
                  estrutura={response['BasicData']}
                ></BasicData>
              ) : (
                ''
              )} */}
              {/* {response.phones_extended ? (
                <PhonesExtended
                  data={response.phones_extended}
                  estrutura={dadosTabelas[typeDoc]['PhonesExtended']}
                ></PhonesExtended>
              ) : (
                ''
              )} */}

              {/* {response.ph3a_data ? (
                response.ph3a_data.Phones && response.ph3a_data.Phones.length > 0 ? (
                  // eslint-disable-next-line array-callback-return
                  response.ph3a_data.Phones.map((phones: any, index: number) => {


                    return (
                      <div key={index}>
                        <p className='fs-6'>
                          Telefone: {phones.FormattedNumber} - Operador {phones.Operator} <br />
                          Whatsapp: {phones.IsWhatsapp ? 'Sim' : 'Não'}
                          <br />
                          Status:{statusPhones(phones.Status)}
                        </p>
                  
                      </div>
                    )
                 
                  })
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}

              {response.emails_extended ? (
                <EmailsExtended
                  data={response.emails_extended}
                  estrutura={dadosTabelas[typeDoc]['EmailsExtended']}
                ></EmailsExtended>
              ) : (
                ''
              )}
              {response.addresses_extended ? (
                <AddressesExtended
                  data={response.addresses_extended}
                  estrutura={dadosTabelas[typeDoc]['AddressesExtended']}
                ></AddressesExtended>
              ) : (
                ''
              )}
              {typeDoc === 'cpf' ? (
                <>
                  {response.related_people ? (
                    <RelatedPeople
                      data={response.related_people}
                      estrutura={dadosTabelas[typeDoc]['RelatedPeople']}
                    ></RelatedPeople>
                  ) : (
                    ''
                  )}
                  {response.related_people_emails ? (
                    <RelatedPeopleEmails
                      data={response.related_people_emails}
                      estrutura={dadosTabelas[typeDoc]['RelatedPeopleEmails']}
                    ></RelatedPeopleEmails>
                  ) : (
                    ''
                  )}
                  {response.related_people_phones ? (
                    <RelatedPeoplePhones
                      data={response.related_people_phones}
                      estrutura={dadosTabelas[typeDoc]['RelatedPeoplePhones']}
                    ></RelatedPeoplePhones>
                  ) : (
                    ''
                  )}
                </>
              ) : (
                ''
              )} */}
            </div>
          </div>
        </td>
      </tr>
    </>
  )
}
